module.exports = __webpack_public_path__ + "img/PetPark.3874a9fa.svg";